import React from "react";
import PropTypes from "prop-types";
import { Modal as BootstrapModal } from "react-bootstrap";

export default function Modal({ open, children, dialogClass, close }) {
  return (
    <BootstrapModal
      dialogClassName={dialogClass}
      show={open}
      onHide={close}
      backdrop="static"
      keyboard={false}
    >
      {children}
    </BootstrapModal>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  dialogClass: PropTypes.string
};

Modal.defaultProps = {
  open: false,
  dialogClass: ""
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Modal/Modal.jsx